var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsUpGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsUp.svg",
    clipPath: "url(#clip0_1107_512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.252 5.41627C18.9147 3.07346 15.8021 1.78491 12.4943 1.78491C5.66668 1.78491 0.110867 7.34072 0.110867 14.1683C0.110867 16.3494 0.679836 18.4802 1.76199 20.3601L0.00488281 26.7749L6.57034 25.0513C8.37765 26.0386 10.4137 26.5574 12.4887 26.5574H12.4943C19.3164 26.5574 24.9949 21.0016 24.9949 14.1739C24.9949 10.8661 23.5892 7.75908 21.252 5.41627ZM12.4943 24.4711C10.6424 24.4711 8.82948 23.9747 7.25087 23.0376L6.87713 22.8144L2.9836 23.8352L4.02113 20.0365L3.7757 19.6461C2.74374 18.0061 2.20266 16.1151 2.20266 14.1683C2.20266 8.4954 6.82135 3.87671 12.4999 3.87671C15.2499 3.87671 17.8326 4.94771 19.7738 6.89447C21.7149 8.84124 22.9087 11.4239 22.9031 14.1739C22.9031 19.8525 18.1673 24.4711 12.4943 24.4711ZM18.1394 16.7622C17.8326 16.606 16.3097 15.8585 16.0253 15.7581C15.7408 15.6521 15.5344 15.6019 15.328 15.9143C15.1216 16.2267 14.5303 16.9184 14.3462 17.1303C14.1677 17.3367 13.9837 17.3646 13.6769 17.2084C11.8584 16.2992 10.6647 15.5852 9.46538 13.5269C9.14743 12.9802 9.78334 13.0193 10.3746 11.8367C10.475 11.6303 10.4248 11.4518 10.3467 11.2956C10.2686 11.1394 9.64946 9.6166 9.39287 8.99743C9.14185 8.39499 8.88526 8.47866 8.6956 8.46751C8.5171 8.45635 8.31071 8.45635 8.10432 8.45635C7.89793 8.45635 7.56324 8.53444 7.27876 8.84124C6.99427 9.15361 6.1966 9.90108 6.1966 11.4239C6.1966 12.9467 7.30665 14.4194 7.45726 14.6258C7.61345 14.8321 9.6383 17.9559 12.7453 19.3002C14.7088 20.1481 15.4786 20.2206 16.4604 20.0756C17.0572 19.9863 18.29 19.3281 18.5466 18.603C18.8032 17.8778 18.8032 17.2586 18.7251 17.1303C18.6526 16.9909 18.4462 16.9128 18.1394 16.7622Z",
    fill: "#ab9788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.99,
    height: 28.56,
    fill: "white",
    transform: "translate(0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsUpGold);
export default __webpack_public_path__ + "static/media/whatsUp_gold.7a8dcbfcc09b992cc857204a8da4ee56.svg";
export { ForwardRef as ReactComponent };